/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const upcomingSchema = z.object({
  dueTomorrow: z.number().int(),
  dueNext7Days: z.number().int(),
});

export type IUpcoming = z.infer<typeof upcomingSchema>;
